import React, { useState, useEffect } from "react";
import "../../css/PinConfigModal.css";
import { sendCommand } from "../../utils/deviceConnectionManager";


export default function PinConfigModal({
  isOpen,
  onClose,
  onSave,
  initialData,
}) {
  const [pin, setPin] = useState(initialData?.pin || "IO2");
  const [mode, setMode] = useState(
    initialData?.type === "setDigital" ? "output" : initialData?.mode || "input"
  );
  const [state, setState] = useState(initialData?.state || "low");
  const [blockType, setBlockType] = useState(initialData?.type || "setDigital"); // 👈 added type prop

  useEffect(() => {
    if (isOpen) {
      setPin(initialData?.pin || "IO2");
      setMode(
        initialData?.type === "setDigital" ? "output" : initialData?.mode || "input"
      );
      setState(initialData?.state || "low");
      setBlockType(initialData?.type || "setDigital");
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const handleSave = async () => {
    const pinNumber = parseInt(pin.replace("IO", ""), 10);

    try {
      if (blockType === "setPinMode") {
        await sendCommand(`SET_PIN_MODE ${pinNumber} ${mode.toUpperCase()}`);
        console.log(`✅ Pin ${pinNumber} mode set to ${mode}`);
      }

      else if (blockType === "setDigital") {
        await sendCommand(`SET_PIN_MODE ${pinNumber} OUTPUT`);

        // Required delay for Serial stability
        await new Promise(r => setTimeout(r, 100));

        // 🔴 SPECIAL HANDLING FOR GPIO 2 (BOOT STRAP PIN)
        if (pinNumber === 2) {
          await sendCommand(`SET_DIGITAL_OUTPUT 2 0`);
          await new Promise(r => setTimeout(r, 60));
        }

        const value = state === "high" ? 1 : 0;
        await sendCommand(`SET_DIGITAL_OUTPUT ${pinNumber} ${value}`);

        console.log(`✅ Pin ${pinNumber} set to ${state}`);
      }

      onSave({ pin, mode, state });

    } catch (error) {
      console.error("❌ Pin control error:", error);
      alert(error.message);
    }
  };


  return (
    <div className="pin-modal-overlay">
      <div className="pin-modal">
        <h3>⚙️ Configure ESP32 Pin</h3>

        {/* Common field: Pin */}
        <div className="pin-field">
          <label>Pin</label>
          <select value={pin} onChange={(e) => setPin(e.target.value)}>
            {Array.from({ length: 34 }, (_, i) => (
              <option key={i} value={`IO${i}`}>
                IO{i}
              </option>
            ))}
          </select>
        </div>

        {/* Conditional rendering */}
        {blockType === "setDigital" && (
          <div className="pin-field">
            <label>State</label>
            <select value={state} onChange={(e) => setState(e.target.value)}>
              <option value="low">Low</option>
              <option value="high">High</option>
            </select>
          </div>
        )}

        {blockType === "readDigital" && (
          <div className="pin-field">
            <label>Mode</label>
            <select value={mode} onChange={(e) => setMode(e.target.value)}>
              <option value="input">Input</option>
              <option value="output">Output</option>
              <option value="input_pullup">Input Pull-up</option>
            </select>
          </div>
        )}

        <div className="pin-modal-buttons">
          <button onClick={handleSave}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
